import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = (values, props) => {
  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values.dynamicFooterBlock && values.dynamicFooterBlock.length > 0) {
    const dynamicFooterBlockErrors = values.dynamicFooterBlock.map(item => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item?.language || item?.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item?.title1) {
        itemErrors.title1 = messages.required;
      } else if (item.title1.trim() === '') {
        itemErrors.title1 = messages.required;
      } else if (item.title1.length > inputTextLimit) {
        itemErrors.title1 = messages.inputTextLimitError;
      }

      if (!item?.content1) {
        itemErrors.content1 = messages.required;
      } else if (item.content1.trim() === '') {
        itemErrors.content1 = messages.required;
      } else if (item.content1.length > inputDescLimit) {
        itemErrors.content1 = messages.inputDescLimitError;
      }

      if (!item?.title2) {
        itemErrors.title2 = messages.required;
      } else if (item.title2.trim() === '') {
        itemErrors.title2 = messages.required;
      } else if (item.title2.length > inputTextLimit) {
        itemErrors.title2 = messages.inputTextLimitError;
      }

      if (!item?.content2) {
        itemErrors.content2 = messages.required;
      } else if (item.content2.trim() === '') {
        itemErrors.content2 = messages.required;
      } else if (item.content2.length > inputDescLimit) {
        itemErrors.content2 = messages.inputDescLimitError;
      }

      if (!item?.title3) {
        itemErrors.title3 = messages.required;
      } else if (item.title3.trim() === '') {
        itemErrors.title3 = messages.required;
      } else if (item.title3.length > inputTextLimit) {
        itemErrors.title3 = messages.inputTextLimitError;
      }

      if (!item?.content3) {
        itemErrors.content3 = messages.required;
      } else if (item.content3.trim() === '') {
        itemErrors.content3 = messages.required;
      } else if (item.content3.length > inputDescLimit) {
        itemErrors.content3 = messages.inputDescLimitError;
      }

      return itemErrors;
    });

    if (dynamicFooterBlockErrors.some(item => Object.keys(item).length > 0)) {
      errors.dynamicFooterBlock = dynamicFooterBlockErrors;
    }
  }

  return errors;
};

export default validate;